<script setup lang="ts">
import type { IDrawerTextBlockProps } from '../types'

const props = defineProps<IDrawerTextBlockProps>()
</script>

<template>
    <section>
        <VDivider
            v-if="props.topDivider"
            class="mb-md"
        />

        <div
            v-if="props.title"
            v-html-gpp="props.title"
            class="text-heading-xs font-boldest text-neutral-primary"
        />

        <div
            v-if="props.paragraph"
            v-html-gpp="props.paragraph"
            class="text-paragraph-md text-neutral-primary mt-base"
        />

        <div
            v-if="props.link"
            class="mt-base"
        >
            <VLink
                id="link"
                :href="props.link?.action?.url"
                class="text-comp-high-contrast"
                size="MEDIUM"
                data-test="link"
                :download="props.link.action?.downloadedAsset?.asset?.links?.site?.href"
                :target="props.link.action?.openInNewTab ? '_blank' : '_self'"
            >
                {{ props.link.label }}
                <VIcon
                    v-if="props.link.visualVariant === 'chevron'"
                    name="chevron-right"
                    size="SMALL"
                    data-test="CTA_BLOCK_LINK-CHEVRON"
                />
            </VLink>
        </div>
    </section>
</template>
